import { Link, useNavigate } from "react-router-dom";
import { CV_ARTISTIC_PATH, CV_PATH, getText, Lang } from "../../i18n";
import { useLanguage } from "../../LanguageContext";
import { useUi } from "../../UiContext";
import BrandName from "./BrandName";
import ContactForm from "./ContactForm";
import WaveDivider from "../home/WaveDivider";
import { socialIcon } from "../Icons";

export default function Footer() {
	const { text, lang, setLang } = useLanguage();
	const { openPrivacy, showNotice } = useUi();
	const navigate = useNavigate();

	const goHomeTop = () => {
		navigate("/");
		window.history.replaceState(null, "", "/");
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	};

	const switchLang = (next: Lang) => {
		setLang(next);
		showNotice(getText(next).site.lang.changed);
	};

	return (
		<footer id="contact" className="site-footer">
			<div className="site-footer-inner">
				<div className="footer-brand">
					<div className="footer-brand-identity">
						<BrandName />
					</div>
					<ContactForm />
				</div>
				<WaveDivider />
				<div className="footer-cols">
					<div>
						<h3>{text.footer.sitemap}</h3>
						<ul>
							<li>
								<Link
									to="/"
									onClick={(event) => {
										event.preventDefault();
										goHomeTop();
									}}
								>
									{text.footer.home}
								</Link>
							</li>
							{text.footer.nav.map((item) => (
								<li key={item.id}>
									{item.external ? (
										<a href={item.to} target="_blank" rel="noreferrer">
											{item.label}
										</a>
									) : (
										<Link to={item.to}>{item.label}</Link>
									)}
								</li>
							))}
						</ul>
					</div>
					<div>
						<h3>{text.footer.connect}</h3>
						<ul>
							{text.site.socials.map((social) => {
								const Icon = socialIcon(social.id);
								const isMail = social.url.startsWith("mailto:");
								return (
									<li key={social.id}>
										<a
											href={social.url}
											{...(isMail
												? {}
												: { target: "_blank", rel: "noreferrer" })}
										>
											<Icon width="14" height="14" />
											{social.label}
										</a>
									</li>
								);
							})}
						</ul>
					</div>
					<div className="footer-cols-stack">
						<div>
							<h3>{text.footer.cv}</h3>
							<ul>
								<li>
									<a href={CV_PATH} target="_blank" rel="noreferrer">
										{text.footer.cvStandard}
									</a>
								</li>
								<li>
									<a href={CV_ARTISTIC_PATH} target="_blank" rel="noreferrer">
										{text.footer.cvArtistic}
									</a>
								</li>
							</ul>
						</div>
						<div>
							<h3>{text.footer.language}</h3>
							<div className="lang-switch" role="group">
								<button
									type="button"
									className={lang === "it" ? "is-active" : ""}
									onClick={() => switchLang("it")}
								>
									IT
								</button>
								<button
									type="button"
									className={lang === "fr" ? "is-active" : ""}
									onClick={() => switchLang("fr")}
								>
									FR
								</button>
								<button
									type="button"
									className={lang === "en" ? "is-active" : ""}
									onClick={() => switchLang("en")}
								>
									EN
								</button>
							</div>
						</div>
					</div>
				</div>
				<WaveDivider />
				<div className="footer-bottom">
					<p>{text.footer.copyright}</p>
					<button
						type="button"
						className="footer-bottom-privacy"
						onClick={openPrivacy}
					>
						{text.footer.privacy}
					</button>
					<p>{text.footer.inProgress}</p>
				</div>
			</div>
		</footer>
	);
}
